import React, { useEffect, useRef, useState } from "react";
import { Form, Formik, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import GeneratorRegionCharges from "./generatorRegionCharges";
import BuyerRegionCharges from "./buyerRegionCharges";
import "./landingcostcalculator.css";
import { Col, Row } from "react-bootstrap";
import { getAllEnergyTypes } from "../../store/ConsumerCapacity/action";
import { useDispatch, useSelector } from "react-redux";
import categoryService from "../../components/Services/category.service";
import stateCityService from "../../components/Services/stateCity.service";
import discomService from "../../components/Services/discom.service";
import landingCostCalculatorService from "../../components/Services/landingCostCalculator.service";
import { toast } from "react-toastify";
import { toastProperties } from "../../commons/Toast/Toaster";
import { CircularProgress, Typography } from "@mui/material";

const LandingCostCalculator = () => {
 const [categoryOptions, setCategoryOptions] = useState([]);
 const [stateOptions, setStateOptions] = useState([]);
 const [discomOptions, setDiscomOptions] = useState([]);
 const [discomOptionsDrawal, setDiscomOptionsDrawal] = useState([]);
 const [calculatedValues, setCalculatedValues] = useState(null);
 // const [shouldScroll, setShouldScroll] = useState(false);
 const [isLoader, setIsLoader] = useState(false);
 const [isError, setIsError] = useState(null);

 const dispatch = useDispatch();

 const energyTypes = useSelector(
  (state) => state?.consumerCapacityReducer?.energyTypes || []
 );

 const initialValues = {
  consumerCategory: "",
  typeOfEnergy: "",
  powerScheduled: "",
  noOfDays: "",
  noOfHours: "",
  energyRate: "",
  injectionState: "",
  injectionDiscom: "",
  injectionVoltageLevel: "",
  drawalState: "",
  drawalDiscom: "",
  drawalVoltageLevel: "",
 };

 const valuesRef = useRef(initialValues);
 const submitButtonRef = useRef(null);

 const validationSchema = Yup.object().shape({
  consumerCategory: Yup.string().required("Required field"),
  typeOfEnergy: Yup.string().required("Required field"),
  energyRate: Yup.number().test(
    'valueRange',
    'Value must be greater than or equal to 1',
    (value) => {
      if (value === undefined || value === null) {
        return true;
      }
      const decimal = String(value).split('.')[1];
      return value >= 1
    }
  ).required("Required field"),
  injectionState: Yup.string().required("Required field"),
  injectionDiscom: Yup.string().required("Required field"),
  injectionVoltageLevel: Yup.string().required("Required field"),
  drawalState: Yup.string().required("Required field"),
  drawalDiscom: Yup.string().required("Required field"),
  drawalVoltageLevel: Yup.string().required("Required field"),
  powerScheduled: Yup.number().test(
    'valueRange',
    'Value must be greater than or equal to 1',
    (value) => {
      if (value === undefined || value === null) {
        return true;
      }
      const decimal = String(value).split('.')[1];
      return value >= 1
    }
  ).required("Required field"),
  noOfDays: Yup.number().test(
    'valueRange',
    'Value must be greater than or equal to 1',
    (value) => {
      if (value === undefined || value === null) {
        return true;
      }
      const decimal = String(value).split('.')[1];
      return value >= 1
    }
  ).required("Required field"),
  noOfHours: Yup.number().test(
    'valueRange',
    'Value must be between 0 and 24',
    (value) => {
      if (value === undefined || value === null) {
        return true;
      }
      const decimal = String(value).split('.')[1];
      return value >= 0 && value <=24 
    }
  ).required("Required field"),
 });

 const getAllCategory = () => {
  categoryService
   .getAllCategory("CONSUMER")
   .then((response) => {
    setCategoryOptions(response?.data?.data);
   })
   .catch((error) => {
    console.log("CategoryOptionsError :", error);
   });
 };

 const getAllStates = () => {
  stateCityService
   .getAllState()
   .then((response) => {
    setStateOptions(response?.data?.data);
   })
   .catch((error) => {
    console.log("StateOptionsError :", error);
   });
 };

 const getDiscomByStateId = (id) => {
  discomService
   .getDiscomById(id)
   .then((response) => {
    setDiscomOptions(response?.data?.data);
   })
   .catch((error) => {
    console.log("DiscomOptionsError :", error);
   });
 };

 const handleStateChange = (id) => {
  getDiscomByStateId(id);
 };

 const getDiscomByStateIdDrawal = (id) => {
  discomService
   .getDiscomById(id)
   .then((response) => {
    setDiscomOptionsDrawal(response?.data?.data);
   })
   .catch((error) => {
    console.log("DiscomOptionsError :", error);
   });
 };

 const handleStateChangeDrawal = (id) => {
  getDiscomByStateIdDrawal(id);
 };

 useEffect(() => {
  getAllCategory();
  getAllStates();
  getAllEnergyTypes()(dispatch);
 }, []);

 // useEffect(() => {
 //   if (shouldScroll && submitButtonRef.current) {
 //     const yOffset = -60; // Adjust this value as needed to position the button correctly
 //     window.scrollTo({
 //       top: submitButtonRef.current.offsetTop + yOffset,
 //       behavior: "smooth",
 //     });
 //     setShouldScroll(false); // Reset shouldScroll to false after scrolling
 //   }
 // }, [shouldScroll]);
 const numberInputOnWheelPreventChange = (e) => {
  // Prevent the input value change
  e.target.blur();

  // Prevent the page/container scrolling
  e.stopPropagation();

  // Refocus immediately, on the next tick (after the current function is done)
  setTimeout(() => {
   e.target.focus();
  }, 0);
 };
 return (
  <>
   <Formik
    initialValues={initialValues}
    validationSchema={validationSchema}
    validateOnMount={false}
    onValuesChange={(nextValues) => {
     valuesRef.current = nextValues;
    }}
    onSubmit={(values) => {
     setIsLoader(true);
     setCalculatedValues(null);
     setIsError(null);
     const reqBody = {
      energyTypeId: +values.typeOfEnergy,
      generatorDiscomId: +values.injectionDiscom,
      generatorVoltageLevel: values.injectionVoltageLevel,
      consumerDiscomId: +values.drawalDiscom,
      consumerVoltageLevel: values.drawalVoltageLevel,
      powerScheduled: values.powerScheduled ? +values.powerScheduled : null,
      noOfHours: values.noOfHours ? +values.noOfHours : null,
      noOfDays: values.noOfDays ? +values.noOfDays : null,
      energyRate: +values.energyRate,
      consumerCategoryId: +values.consumerCategory,
     };
     landingCostCalculatorService
      .getLandingCostCalculator(reqBody)
      .then((response) => {
       if (response?.data?.code === 200) {
        setIsLoader(false);
        setCalculatedValues(response?.data?.data);
       } else {
        setIsLoader(false);
        setIsError(response?.data);
        toast.error(response?.data?.error, toastProperties);
       }
      })
      .catch((error) => {
       console.log("StateOptionsError :", error);
      });
    }}
    onReset={(values, formikBag) => {
     setCalculatedValues(null);
     setDiscomOptions([]);
     setDiscomOptionsDrawal([]);
     // Handle the form reset here, if needed
     // This function is called when the reset button is clicked
     // You can also access the Formik context via formikBag
     // For example, you can reset some other state or perform additional actions.
    }}
   >
    {({
     isSubmitting,
     setFieldTouched,
     setFieldValue,
     values,
     handleBlur,
     errors,
    }) => {
      console.log("LCC===>",{values,errors})
     return (
      <Form>
       <section className="mb-lg-5 my-4">
        <div className=" container pt-2">
         <div className="landingcost-card-title mb-2">Consumer Details</div>
         <Row className="g-0 power-sch-wrap mb-3">
          {/* First Row */}
          <Col md={4} className="pe-4">
           <div className="mb-2">
            <div className="position-relative">
             <label
              className={`landingcost-label ${
               values.consumerCategory ? "landingcost-label-default" : ""
              }`}
             >
              Consumer Category*
             </label>
             <Field
              as="select"
              className="custom-input custom-input-select"
              name="consumerCategory"
             >
              <option value="" className="empty-option"></option>
              {categoryOptions?.map((item) => (
               <option key={item.id} value={item.id}>
                {item.name}
               </option>
              ))}
             </Field>
             <ErrorMessage
              name="consumerCategory"
              component="div"
              className="text-danger"
             />
            </div>
           </div>
          </Col>
          <Col md={4} className="pe-4">
           <div className="mb-2">
            <div className="position-relative">
             <label
              htmlFor="typeOfEnergy"
              className={`landingcost-label ${
               values.typeOfEnergy ? "landingcost-label-default" : ""
              }`}
             >
              Type of Energy*
             </label>
             <Field
              as="select"
              className="custom-input custom-input-select"
              name="typeOfEnergy"
             >
              <option value="" className="empty-option"></option>
              {energyTypes?.map((item) => (
               <option key={item?.id} value={item?.id}>
                {item?.type}
               </option>
              ))}
             </Field>
             <ErrorMessage
              name="typeOfEnergy"
              component="div"
              className="text-danger"
             />
            </div>
           </div>
          </Col>
          <Col md={4}>
           <div className="mb-2">
            <div className="position-relative">
             <label className="postion-label-dynamic">Energy Rate (₹)*</label>
             <Field
              type="number"
              onWheel={numberInputOnWheelPreventChange}
              name="energyRate"
              className=" custom-input"
              onKeyDown={(e) => {
                if (
                 e.key === "-" ||
                 e.key === "+" ||
                 e.key === "e" ||
                 e.key === "ArrowUp" ||
                 e.key === "ArrowDown"
                ) {
                 e.preventDefault();
                }
               }}
             />
             <ErrorMessage
              name="energyRate"
              component="div"
              className="text-danger"
             />
            </div>
           </div>
          </Col>

          <Col md={4} className="pe-4">
           <div className="mb-2">
            <div className="position-relative">
             <label className="postion-label-dynamic" >
              Power Scheduled in MW *
             </label>
             <Field
              type="number"
              onWheel={numberInputOnWheelPreventChange}
              name="powerScheduled"
              className="custom-input"
              onKeyDown={(e) => {
                if (
                 e.key === "-" ||
                 e.key === "+" ||
                 e.key === "e" ||
                 e.key === "ArrowUp" ||
                 e.key === "ArrowDown"
                ) {
                 e.preventDefault();
                }
               }}
             />
             <ErrorMessage
              name="powerScheduled"
              component="div"
              className="text-danger"
             />
            </div>
           </div>
          </Col>
          <Col md={4} className="pe-4">
           <div className="mb-2">
            <div className="position-relative">
             <label className="postion-label-dynamic">No. of Days *</label>
             <Field
              type="number"
              onWheel={numberInputOnWheelPreventChange}
              name="noOfDays"
              className=" custom-input"
              onKeyDown={(e) => {
                if (
                 e.key === "-" ||
                 e.key === "+" ||
                 e.key === "e" ||
                 e.key === "ArrowUp" ||
                 e.key === "ArrowDown"
                ) {
                 e.preventDefault();
                }
               }}
             />
             <ErrorMessage
              name="noOfDays"
              component="div"
              className="text-danger"
             />
            </div>
           </div>
          </Col>
          <Col md={4}>
           <div className="mb-2">
            <div className="position-relative">
             <label className="postion-label-dynamic">
              No. of Hours per Day *
             </label>
             <Field
              type="number"
              onWheel={numberInputOnWheelPreventChange}
              name="noOfHours"
              className=" custom-input"
              onKeyDown={(e) => {
                if (
                 e.key === "-" ||
                 e.key === "+" ||
                 e.key === "e" ||
                 e.key === "ArrowUp" ||
                 e.key === "ArrowDown"
                ) {
                 e.preventDefault();
                }
               }}
             />
             <ErrorMessage
              name="noOfHours"
              component="div"
              className="text-danger"
             />
            </div>
           </div>
          </Col>
         </Row>

         <Row>
          <Col md={6}>
           <div className="landingcost-card-title mb-2">
            Point of Injection (Generator Region)
           </div>
           <div className="power-sch-wrap">
            <div className="mb-2">
             <div className="position-relative">
              <label
               htmlFor="injectionState"
               className={`landingcost-label ${
                values.injectionState ? "landingcost-label-default" : ""
               }`}
              >
               State*
              </label>
              <Field
               as="select"
               className="custom-input custom-input-select"
               name="injectionState"
               onChange={(e) => {
                setFieldValue("injectionState", e.target.value);
                setFieldValue("injectionDiscom", '');
                setFieldValue("injectionVoltageLevel", '');
                handleStateChange(e.target.value);
               }}
              >
               <option value="" className="empty-option"></option>
               {stateOptions?.map((item) => (
                <option key={item?.id} value={item?.id}>
                 {item?.name}
                </option>
               ))}
              </Field>
              <ErrorMessage
               name="injectionState"
               component="div"
               className="text-danger"
              />
             </div>
            </div>
            <div className="mb-2">
             <div className="position-relative">
              <label
               className={`landingcost-label ${
                values.injectionDiscom ? "landingcost-label-default" : ""
               }`}
              >
               Discom*
              </label>
              <Field
               as="select"
               className="custom-input custom-input-select"
               name="injectionDiscom"

              >
               <option value="" className="empty-option"></option>
               {discomOptions?.map((item) => (
                <option key={item?.id} value={item?.id}>
                 {item?.discom} ({item?.acronym})
                </option>
               ))}
              </Field>
              <ErrorMessage
               name="injectionDiscom"
               component="div"
               className="text-danger"
              />
             </div>
            </div>
            <div>
             <div className="position-relative">
              <label
               htmlFor="injectionVoltageLevel"
               className={`landingcost-label ${
                values.injectionVoltageLevel ? "landingcost-label-default" : ""
               }`}
              >
               Voltage Level*
              </label>
              <Field
               as="select"
               className="custom-input custom-input-select"
               name="injectionVoltageLevel"
               value={values.injectionVoltageLevel}
              >
               <option value="" className="empty-option"></option>
               {discomOptions
                ?.find((item) => item.id == values.injectionDiscom)
                ?.voltageLevels?.map((item, i) => (
                 <option key={i} value={item}>
                  {item}{" "}
                 </option>
                ))}
              </Field>
              <ErrorMessage
               name="injectionVoltageLevel"
               component="div"
               className="text-danger"
              />
             </div>
            </div>
           </div>
          </Col>
          <Col md={6}>
           <div className="landingcost-card-title mb-2">
            Point of Drawal (Consumer Region)
           </div>
           <div className="power-sch-wrap">
            <div className="mb-2">
             <div className="position-relative">
              <label
               htmlFor="drawalState"
               className={`landingcost-label ${
                values.drawalState ? "landingcost-label-default" : ""
               }`}
              >
               State*
              </label>
              <Field
               as="select"
               className="custom-input custom-input-select"
               name="drawalState"
               onChange={(e) => {
                setFieldValue("drawalState", e.target.value);
                setFieldValue("drawalDiscom", '');
                setFieldValue("drawalVoltageLevel", '');
                handleStateChangeDrawal(e.target.value);
               }}
              >
               <option value="" className="empty-option"></option>
               {stateOptions?.map((item) => (
                <option key={item?.id} value={item?.id}>
                 {item?.name}
                </option>
               ))}
              </Field>
              <ErrorMessage
               name="drawalState"
               component="div"
               className="text-danger"
              />
             </div>
            </div>
            <div className="mb-2">
             <div className="position-relative">
              <label
               htmlFor="drawalDiscom"
               className={`landingcost-label ${
                values.drawalDiscom ? "landingcost-label-default" : ""
               }`}
              >
               Banking*
              </label>
              <Field
               as="select"
               className="custom-input custom-input-select"
               name="drawalDiscom"
              >
               <option value="" className="empty-option"></option>
               {discomOptionsDrawal?.map((item) => (
                <option key={item?.id} value={item?.id}>
                 {item?.discom} ({item?.acronym})
                </option>
               ))}
              </Field>
              <ErrorMessage
               name="drawalDiscom"
               component="div"
               className="text-danger"
              />
             </div>
            </div>
            <div>
             <div className="position-relative">
              <label
               htmlFor="drawalVoltageLevel"
               className={`landingcost-label ${
                values.drawalVoltageLevel ? "landingcost-label-default" : ""
               }`}
              >
               Voltage Level*
              </label>
              <Field
               as="select"
               className="custom-input custom-input-select"
               name="drawalVoltageLevel"
               value={values.drawalVoltageLevel}
              >
               <option value="" className="empty-option"></option>
               {discomOptionsDrawal
                ?.find((item) => item.id == values.drawalDiscom)
                ?.voltageLevels?.map((item, i) => (
                 <option key={i} value={item}>
                  {item}
                 </option>
                ))}
              </Field>
              <ErrorMessage
               name="drawalVoltageLevel"
               component="div"
               className="text-danger"
              />
             </div>
            </div>
           </div>
          </Col>
         </Row>
         <div className="row mt-3 ">
          <div className="col-md-12 text-center">
           <div
            className="company-profile-btn-group"
            style={{ justifyContent: "center" }}
           >
            <button
             type="Submit"
             className="btn btn-approve"
             ref={submitButtonRef}
            >
             Submit
            </button>
            <button type="reset" className="btn btn-withdrawal">
             Clear All
            </button>
           </div>
          </div>
         </div>
         {isError != null ? (
          <div className="text-center mt-4">
           <Typography level="h4">{isError?.error}</Typography>{" "}
          </div>
         ) : isLoader ? (
          <div className="text-center mt-4">
           <CircularProgress />
          </div>
         ) : (
          calculatedValues && (
           <>
            <div className="row my-3">
             <div className="col-md-12 d-flex justify-content-center">
              <div className="grand-total-box">
               <div className="scheduler-border">
                <div className="seller-landing-cost-label">
                 Landing Cost: Third Party/PPA
                </div>
                <div className="total-row">
                 {calculatedValues?.grandTotalThirdParty && (
                  <div className="total-row-col shadow-sm">
                   <h6>Total</h6>
                   <div>
                    ₹{" "}
                    {calculatedValues?.grandTotalThirdParty?.toLocaleString(
                     undefined,
                     { minimumFractionDigits: 2, maximumFractionDigits: 2 }
                    )}
                   </div>
                  </div>
                 )}
                 <div className="total-row-col shadow-sm">
                  <h6>₹ Per Unit</h6>
                  <div>
                   {calculatedValues?.landedCostThirdParty?.toLocaleString(
                    undefined,
                    { minimumFractionDigits: 2, maximumFractionDigits: 2 }
                   )}
                  </div>
                 </div>
                </div>
               </div>
               <div className="scheduler-border">
                <div className="seller-landing-cost-label">
                 Landing Cost: Own Captive
                </div>
                <div className="total-row">
                 {calculatedValues?.grandTotalOwnCaptive && (
                  <div className="total-row-col shadow-sm">
                   <h6>Total</h6>
                   <div>
                    ₹{" "}
                    {calculatedValues?.grandTotalOwnCaptive?.toLocaleString(
                     undefined,
                     { minimumFractionDigits: 2, maximumFractionDigits: 2 }
                    )}
                   </div>
                  </div>
                 )}
                 <div className="total-row-col shadow-sm">
                  <h6>₹ Per Unit</h6>
                  <div>
                   {" "}
                   {calculatedValues?.landedCostOwnCaptive?.toLocaleString(
                    undefined,
                    { minimumFractionDigits: 2, maximumFractionDigits: 2 }
                   )}
                  </div>
                 </div>
                </div>
               </div>
              </div>
             </div>
            </div>
            <div>
             <hr className="landing-hr" />
             <div className="row">
              <GeneratorRegionCharges calculatedValues={calculatedValues} />
              <BuyerRegionCharges calculatedValues={calculatedValues} />
             </div>
            </div>
           </>
          )
         )}
        </div>
       </section>
      </Form>
     );
    }}
   </Formik>
  </>
 );
};

export default LandingCostCalculator;
